import Swal from 'sweetalert2';
import componentManager from 'app/module46/component-manager.js';

componentManager.register('stripe', (component, elements, attributes, properties) => {

	const $component = $(component);
	
	const { publishableKey, sessionId } = properties;

	const stripe = Stripe(publishableKey);

	$component.on('click', () => {
		stripe.redirectToCheckout({
			sessionId: sessionId
		}).then((result) => {
			Swal.fire('', result.error.message, 'error');
		});
	});
});
